import React, { useCallback, useEffect, useState } from 'react';
import Loading from '../../../components/loading/Loading';
import useStyles from './styles';
import {
    PAYMENT_STANCER_URL,
    STANCER_PAYMENT_STATUS,
} from '../../../components/myeirconstant/myEirConstant';
import { getAddCardIframe, validateAddCard } from './stancer.util';
import { useApolloClient } from '@apollo/client';
import { Box, Typography } from '@material-ui/core';
import MyEirChangeSuccessModal from '../../my-account/MyEirChangeSuccessModal';
import CustomUpdatedPopUpModal from '../../eir-porting/CustomModal/CustomUpdatedPopUpModal';
import errorIcon from '../../../mobilecomponents/images/warning.png';

const {
    FINISHED,
    ERROR,
    PENDING,
    SECURE_AUTH_END,
    SECURE_AUTH_ERROR,
    SECURE_AUTH_START,
    INIT,
    INVALID,
} = STANCER_PAYMENT_STATUS;
/**
 * @name StancerPaymentContainer - jsx component for Stancer flow
 * @param {object} props - Object containing react props
 * @returns {JSX.Element} - Renders StancerPaymentContainer component
 */
const StancerAddCardContainer = props => {
    const graphql = useApolloClient();
    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [hpp, setHpp] = useState(null);
    const [isopen, setIsopen] = useState(false);
    const [cardAdded, setCardAdded] = useState(false);
    const [isOpen4, setIsopen4] = useState(false);
    const [openErrorPopup, setOpenErrorPopup] = useState(false);

    function toggle4() {
        setIsopen4(!isOpen4);
    }
    function toggle() {
        setIsopen(!isopen);
    }

    /**
     * @function handleToggleErrorPopup
     * @description Function toggle stancer status error
     */
    const handleToggleErrorPopup = () => {
        setOpenErrorPopup(!openErrorPopup);
    };

    /**
     * @function onLoadGetAddCardFrame
     * @description Function to load add card iframe
     */
    const onLoadGetAddCardFrame = () => {
        getAddCardIframe({ graphql, setHpp, setLoading, setOpenErrorPopup });
        setOpenErrorPopup(false);
    };
    useEffect(() => {
        onLoadGetAddCardFrame();
    }, []);

    /**
     * @function submitPayment
     * @description Function for submitting add card payemnt using message event handler
     */
    const submitPayment = useCallback(
        event => {
            if (event.origin !== PAYMENT_STANCER_URL) {
                return;
            }
            if (event?.data?.status === PENDING) {
                return;
            }
            if (event?.data?.status === SECURE_AUTH_END) {
                return;
            }
            if (event?.data?.status === SECURE_AUTH_ERROR) {
                return;
            }
            if (event?.data?.status === SECURE_AUTH_START) {
                return;
            }
            if (event?.data?.status === INIT) {
                return;
            }
            if (event?.data?.status === ERROR || event?.data?.status === INVALID) {
                setOpenErrorPopup(true);
            }
            if (event?.data?.status === FINISHED) {
                const paymentId = hpp?.paymentIntentId;
                if (paymentId)
                    validateAddCard({
                        graphql,
                        paymentId,
                        setCardAdded,
                        toggle,
                        setOpenErrorPopup,
                    });
            }
        },
        [hpp?.paymentIntentId, graphql]
    );

    useEffect(() => {
        window.addEventListener('message', submitPayment, false);
        return () => window.removeEventListener('message', submitPayment);
    }, [submitPayment]);

    useEffect(() => {
        props.setHeader('Add new card');
    }, []);

    return (
        <React.Fragment>
            <Box className={classes.PaymentIframeModal}>
                {loading && <Loading />}
                {!loading && hpp && (
                    <>
                        <iframe
                            id='target-iframe'
                            title='stancer-selfcare-add-card-iframe'
                            frameBorder='0'
                            src={hpp?.url}
                            height={window?.innerWidth <= 768 ? '700px' : '820px'}
                            width={'100%'}
                        />
                    </>
                )}
            </Box>
            {openErrorPopup && (
                <Box id='my-eir-pop-up'>
                    <CustomUpdatedPopUpModal
                        open={openErrorPopup}
                        toggle={handleToggleErrorPopup}
                        cta1={{
                            text: 'Try again ',
                            action: () => {
                                onLoadGetAddCardFrame();
                            },
                            disable: false,
                        }}
                        cta2={{ text: '', action: () => {} }}
                    >
                        <Box className={classes.successPopup}>
                            <Box className={classes.successImg}>
                                <Typography component='img' src={errorIcon} alt='failure' />
                            </Box>

                            <Typography className={classes.imgTextAdditional}>
                                Sorry something went wrong! Please try again.
                            </Typography>
                        </Box>
                    </CustomUpdatedPopUpModal>
                </Box>
            )}
            <MyEirChangeSuccessModal
                isOpen={isopen}
                toggle={toggle}
                toggle1={toggle4}
                resetStep={() => props.resetStep()}
                successText={
                    cardAdded
                        ? 'Your new card has been successfully added. It will now be your default payment method'
                        : 'Something went wrong and the card wasn’t added. Please try again later'
                }
                codeStatus={cardAdded}
                buttonText='Close'
            />
        </React.Fragment>
    );
};

export default StancerAddCardContainer;
